module.exports = __webpack_public_path__ + "img/autorizacao-cancelamento.6f6f511e.png";